const PASSWORD_MESSAGES = {
  SUCCESS_STATE: 'Success State',
  RESET_PASSWORD: 'Reset your Password',
  PASSWORD_INSTRUCTION:
    'Min 6 characters. At least one uppercase character. At least one lower case character. At least one number',
  PASSWORD_MISMATCH: 'Passwords do not match',
  BUTTON_TEXT: 'Change Password',
  CREATE: 'Create a New Password',
  CONFIRM: 'Confirm Password',
  CURRENT: 'Current Password',
  CURRENT_PASSWORD_INSTRUCTION:
    'To change your password, please enter your current password.'
};

export { PASSWORD_MESSAGES };
